module.exports = __webpack_public_path__ + "static/assets/5c04404ee3548421d3ed012f29865843.svg";